import { createAsyncStore } from "common/axios/asyncModel";
import { PaymentRepository } from "repository/paymentRepository";

// 정산 목록 조회
const paymentList = createAsyncStore();
const onGetPaymentList = (meetingId: string) => {
    paymentList.onGetAll(() => PaymentRepository.onGetPayments(meetingId));
}

// 정산 상세 조회
const paymentDetail = createAsyncStore();
const onGetPaymentDetail = (paymentId: string) => {
    paymentDetail.onGetAll(() => PaymentRepository.onGetPaymentDetail(paymentId));
}

// 정산 생성
const createPayment = createAsyncStore();
const onCreatePayment = (meetingId: string, params: any) => {
    createPayment.onGetAll(() => PaymentRepository.onPostCreatePayment(meetingId, params));
}

// 정산 요청
const requestPayment = createAsyncStore();
const onRequestPayment = (paymentId: string, params?: any) => {
    requestPayment.onGetAll(() => PaymentRepository.onPostRequestPayment(paymentId, params));
}

// 정산 완료
const completePayment = createAsyncStore();
const onCompletePayment = (paymentId: string, params?: any) => {
    completePayment.onGetAll(() => PaymentRepository.onPostCompletePayment(paymentId, params));
}

// 영수증 OCR
const receiptOcr = createAsyncStore();
const onReceiptOcr = (meetingId: string, formData: FormData) => {
    receiptOcr.onGetAll(() => PaymentRepository.onPostReceiptOcr(meetingId, formData));
}

export const paymentStore = {
    paymentList,
    onGetPaymentList,

    paymentDetail,
    onGetPaymentDetail,

    createPayment,
    onCreatePayment,

    requestPayment,
    onRequestPayment,

    completePayment,
    onCompletePayment,

    receiptOcr,
    onReceiptOcr
}
